<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnCheckbox, BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineScheduleChangeConfirm } from '../../model/modal-discipline-schedule-change-confirm.hook'
import { SCHEDULE_CONFIRM_TEXT } from '../../model/discipline-schedule'
import DisciplineScheduleConfirmSection from '../DisciplineScheduleConfirmSection.vue'

defineOptions({
  name: 'ModalDisciplineScheduleChangeConfirm',
})

const {
  refInfoText,
  refSlots,
  refStartText,
  refIsConfirmed,
  refConfirmMode,
  refIsSaving,
  toggleConfirmed,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleChangeConfirm()
</script>

<template>
  <ModalDefault
    show
    title="Confirm weekly schedule"
    :loading="refIsSaving"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-confirm">
      <div class="modal-discipline-schedule-confirm__info">
        <AppText name="body1">
          {{ refInfoText }}
        </AppText>
        <AppText name="body1">
          Check new schedule, start date and confirm changes.
        </AppText>
      </div>
      <div class="modal-discipline-schedule-confirm__box">
        <DisciplineScheduleConfirmSection
          title="New weekly recurring schedule:"
          :items="refSlots"
        />
        <div class="modal-discipline-schedule-confirm__divider" />
        <DisciplineScheduleConfirmSection
          title="Schedule starts from:"
          :items="[refStartText]"
        />
      </div>
      <BtnCheckbox
        required
        :checked="refIsConfirmed"
        :mode="refConfirmMode"
        :text="SCHEDULE_CONFIRM_TEXT"
        @click="toggleConfirmed"
      />
    </div>
    <template #controls>
      <BtnPrimary
        text="Confirm schedule"
        color="emerald"
        :disabled="refIsSaving"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        :disabled="refIsSaving"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineScheduleConfirm.scss" />
